<template>
  <div>
    <div class="container">
      <div class="card-primary">
        <div class="card-header">
          <h2 class="card-title mt-4 text-center" style="font-size: 200%">
            Richiesta di pubblicazione su linkedin del caso:
            <u>{{ clinicalCase.name }}</u>
          </h2>
          <p class="m-4" style="font-size: 130%">
            La richiesta verrà inviata agli amministratori di neurohub che
            controllerrano la corretteza dei dati richiesti e provvederanno alla
            pubblicazione del caso con il vostro tag associato al post.
          </p>
        </div>
        <form @submit.prevent="publishClinicalCase">
          <div class="card-body">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="nome_post">Testo del post</label>
                    <input
                      type="text"
                      class="form-control"
                      id="nome_post"
                      name="post_text"
                      placeholder="Scrivi il testo che vuoi scrivere nel post da pubblicare"
                      v-model="linkedinForm.post_text"
                      required
                    />
                    <div class="alert alert-danger" v-if="errors.post_text">
                      {{ errors.post_text[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="link_profile"
                      >Link del tuo profilo linkedin</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="link_profile"
                      name="link_profile"
                      v-model="linkedinForm.link_profile"
                      placeholder="Inserisci il link del profilo"
                      required
                    />
                    <div class="alert alert-danger" v-if="errors.link_profile">
                      {{ errors.link_profile[0] }}
                    </div>
                    <p>
                      <small
                        >Il link è necessario per permettere a neurohub di fare
                        il tag</small
                      >
                    </p>
                  </div>
                </div>
              </div>

              <div v-if="attachments.length > 0" class="row">
                <div
                  class="col-md-4"
                  v-for="attachment in attachments"
                  :key="attachment.name"
                >
                  <div class="form-group">
                    <input
                      type="radio"
                      :id="'linkedin-image-' + attachment.id"
                      name="image"
                      v-model="linkedinForm.image"
                      :value="attachment.id"
                    />
                    <label :for="'linkedin-image-' + attachment.id">{{
                      attachment.nome
                    }}</label
                    ><br />
                    <img :src="attachment.path" class="img-thumbnail" alt="" />
                  </div>
                </div>
              </div>
              <div v-else>
                <p>Non ci sono immagini nel post</p>
              </div>
            </div>
          </div>
          <hr />
          <div class="row mb-4 mt-2">
            <div class="ml-4">
              <router-link to="/casi-clinici" class="btn btn-danger"
                >Pubblica il caso normalmente e non su linkedin</router-link
              >
            </div>
            <div class="ml-4">
              <button type="submit" class="btn btn-primary">
                Invia la richiesta di pubblicazione
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import httpauth from "@/services/httpauth.js";
import router from "@/router";
import { useAuth } from "@/stores/auth.js";
export default {
  name: "LinkedinPage",
  data() {
    return {
      clinicalCase: {},
      attachments: [],
      linkedinForm: {
        id: 0,
        post_text: "",
        link_profile: "",
        image: 0,
      },
      request: {
        model: "activity",
        model_id: 0,
      },
      errors: [],
      slug: "",
      category: "",
    };
  },
  mounted() {
    this.category = localStorage.getItem("linkedincategory");
    this.slug = localStorage.getItem("linkedinslug");
    this.getClinicalCase();
  },
  created() {},
  methods: {
    async publishClinicalCase() {
      await httpauth
        .post("/linkedin-request", this.linkedinForm)
        .then((response) => {
          localStorage.removeItem("linkedincategory");
          localStorage.removeItem("linkedinslug");
          if (this.category == "meeting") {
            localStorage.setItem(
              "messageSuccessMeeting",
              response.data.message
            );
            router.push("/meeting");
          } else if (this.category == "clinical-case") {
            localStorage.setItem(
              "messageSuccessClinicalCase",
              response.data.message
            );

            router.push("/casi-clinici");
          }
        })
        .catch((error) => {
          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
          }
        });
    },
    async getClinicalCase() {
      await httpauth
        .get("/linkedin/edit/" + this.slug, [
          {
            params: { slug: this.slug }, // Passa l'ID come oggetto nel campo 'data'
          },
        ])
        .then((response) => {
          this.attachments = response.data.data.attachments;

          this.clinicalCase.id = response.data.data.id;
          this.linkedinForm.id = response.data.data.id;
          this.clinicalCase.name = response.data.data.name;
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          ) {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
  },
};
</script>